import React from 'react';
import './spinner.scss';

//Spinner - render spinner

const Spinner: React.FC = () => (
	<div className='spinner-wrapper text--center width--full box-size--border-box' data-testid='spinner'>
		<div className='loader position--relative height--full m--0-auto'>
			<svg className='circular' viewBox='25 25 50 50'>
				<circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='2' strokeMiterlimit='10' />
			</svg>
		</div>
	</div>
);

const Loader: React.FC<{ className: string }> = (props) => {
	return (
		<div className='loader-wrapper'>
			<div className={`${props.className} loading-icon fa fa-spin fa-spinner`} />
		</div>
	);
};

export { Loader };

export default Spinner;
